const homeState = {
    parent: 'root',
    url: '/',
    onEnter: ($state, currentUser) => {
        currentUser()
            .then(result => {
                if (result && result.roles) {
                    if ((result.roles.length === 1 &&
                        result.roles[0] === 'RRD') ||
                        (result.roles.length === 2 &&
                        result.roles[0] === 'RRD' &&
                        result.roles[1] === 'AccountAdmin')) {
                        // Redirect to letters menu if only rrd role or only rrd and accountadmin roles

                        $state.go('letters.list');
                        return;
                    }

                    if (result.roles.length === 1 &&
                        result.roles[0] === 'AccountAdmin') {
                        // Redirect to dealers menu if only AccountAdmin role
                        $state.go('dealers.list');
                        return;
                    }

                    if (result.roles.length === 1 &&
                        result.roles[0] === 'TradeInvestigations') {
                        // Redirect to Mileage Deletion Request if only TradeInvestigations role
                        $state.go('mileage-deletion.requests');
                        return;
                    }

                    $state.go('tasks');
                }
            });
    }
};

const rootState = {
    parent: 'root',
    url: '/tasks',
    controller: require('./controllers/tasks/tasksCtrl'),
    template: require('./controllers/tasks/tasks.html'),
    onEnter: $rootScope => {
        $rootScope.openTasksPullout = false;
    },
    onExit: $rootScope => {
        $rootScope.openTasksPullout = true;
    }
};

const enquiriesRootState = {
    abstract: true,
    url: '/enquiries',
    controller: require('./controllers/enquiries/enquiriesCtrl'),
    template: require('./controllers/enquiries/enquiries.html'),
    onEnter: $rootScope => {
        $rootScope.openTasksPullout = false;
    },
    onExit: $rootScope => {
        $rootScope.openTasksPullout = true;
    }

};

const enquiriesListState = {
    url: '',
    views: {
        'content@enquiries': {
            template: require('./controllers/enquiries/list/enquiries-list.html'),
            controller: require('./controllers/enquiries/list/enquiriesListCtrl'),
            controllerAs: 'enquiriesList'
        }
    },
    parent: 'enquiries'
};

const enquiryCreateState = {
    url: '/create',
    views: {
        'content@enquiries': {
            template: require('./controllers/enquiries/create/enquiry-create.html'),
            controller: require('./controllers/enquiries/create/enquiryCreateCtrl'),
            controllerAs: 'createEnquiry'
        }
    },
    parent: 'enquiries'
};

const enquiryDetailsState = {
    url: '/{vehicleId}',
    views: {
        'content@enquiries': {
            template: require('./controllers/enquiries/details/enquiry-details.html'),
            controller: require('./controllers/enquiries/details/enquiryDetailsCtrl'),
            controllerAs: 'enquiryDetails'
        }
    }
};

const taskNoLinkState = {
    url: '/nolink',
    views: {
        'content@tasks': {
            template: require('./controllers/nolinktask/nolinktask.html')
        }
    }
};

export default function (app) {
    app.config(($stateProvider, userRolesObject) => {
        rootState.data = {
            roles: [userRolesObject.admin, userRolesObject.operator, userRolesObject.teamLead]
        };

        enquiriesRootState.data = {
            roles: [userRolesObject.admin, userRolesObject.operator, userRolesObject.teamLead]
        };

        $stateProvider
            .state('home', homeState)
            .state('tasks', rootState);

        $stateProvider
            .state('enquiries', enquiriesRootState)
            .state('enquiries.list', enquiriesListState)
            .state('enquiries.create', enquiryCreateState)
            .state('tasks.nolink', taskNoLinkState);

        $stateProvider
            .state('enquiries.details', enquiryDetailsState);
    });

    app.run($rootScope => {
        $rootScope.openTasksPullout = true;
    });
}



// WEBPACK FOOTER //
// ./Client/app/tasks/routes.js